import { Colors } from '@/common/colors/colors';
import { SPEND_SOURCES } from '@/common/constants/spend_sources';

export const getMetaAccountTableRows = (data, onActionClick, onActionSync) => {
	return data?.map((metaAccount) => (
		<tr key={metaAccount.name}>
			<td>{metaAccount.email}</td>
			<td>{metaAccount._add_account.filter((acc) => acc.is_active).length}</td>
			<td>{metaAccount._add_account.filter((acc) => !acc.is_active).length}</td>
			<td>
				<div style={{ display: 'flex', gap: '10px' }}>
					<i
						className='fa fa-edit animation-scale'
						style={{
							cursor: 'pointer',
							color: Colors.darkBlue,
						}}
						onClick={() => onActionClick(metaAccount)}
					/>
					<i
						className='fa fa-sync animation-scale'
						style={{
							cursor: 'pointer',
							color: Colors.darkBlue,
						}}
						onClick={() => onActionSync(metaAccount)}
					/>
				</div>
			</td>
		</tr>
	));
};

export const getAddAccountTableRows = (data, onActionClick) => {
	return data?.map((metaAccount) =>
		metaAccount._add_account.map((addAccount) => (
			<tr key={addAccount.name}>
				<td>{addAccount.name}</td>
				<td>
					{addAccount.source &&
						SPEND_SOURCES.find((opt) => opt.value === addAccount.source)?.label}
				</td>
				<td>{addAccount.add_account_id}</td>
				<td>
					{addAccount.is_active ? (
						<i className='fa-solid fa-check' style={{ color: Colors.green }} />
					) : (
						<i className='fa fa-xmark' style={{ color: Colors.red }} />
					)}
				</td>
				<td>
					<i
						className='fa fa-edit animation-scale'
						style={{
							cursor: 'pointer',
							color: Colors.darkBlue,
						}}
						onClick={() => onActionClick(addAccount)}
					/>
				</td>
			</tr>
		)),
	);
};
